import csvToJson from "../csvToJson";


/**
 * Provided with a CSV file with the rules to provide the Diagnose returns an array with the different rules parsed
 * @param diagnoseConfiguration csv file with the rules
 * @returns {array} An array of object containing the rules
 */
function readRuleSetForDiagnose(diagnoseConfiguration) {
    console.log({
        "msg": "readRuleSetForDiagnose",
        "component": "diagnose"
    })
    // Read this again every time so you get a deep copy when you request it
    return csvToJson(diagnoseConfiguration).filter(line => line.RULE_ID !== '')
}

export default readRuleSetForDiagnose
